export default __webpack_public_path__ + "static/media/airplane.f940914d.svg";